import transport from '../transport'

class Visual {
  constructor (definitions, definitionId) {
    this.definition = this.getVisualDefinition(definitions, definitionId)
  }

  getVisualDefinition (definitions, id) {
    var result = null

    var found = false
    for (var i = 0; i < definitions.length && !found; i++) {
      if (definitions[i].id === id) {
        result = definitions[i]
        found = true
      }
    }

    return result
  }

  getDefinitionFields (reqDef) {
    var result = null
    if (this.definition && reqDef) {
      if (this.definition.aliasExceptions) {
        var found = false
        for (var i = 0; i < this.definition.aliasExceptions.length && !found; i++) {
          if (this.definition.aliasExceptions[i].id === reqDef.id) {
            result = this.definition.aliasExceptions[i]
            found = true
          }
        }
        if (!found) {
          result = this.definition
        }
      } else {
        result = this.definition
      }
    }
    if (result === null) {
      if (reqDef)  {
        if (reqDef.type === 'group') {
          result = {class: 'w3-col'}
        } else {
          result = {class: 'w3-quarter'}  
        }
      } else {
        result = {class: 'w3-col'}
      }
    }
    return result
  }

  getRepeatableGroupPresentation (groupId) {
    var result = null

    if (this.definition && this.definition.repeatableGroupPresentation) {
      for (var i = 0; i < this.definition.repeatableGroupPresentation.length && result === null; i++) {
        if (this.definition.repeatableGroupPresentation[i].id === groupId) {
          result = this.definition.repeatableGroupPresentation[i]
        }
      }
    }

    return result
  }

  getDefinitionFieldsHeader (id, requestDefinition, requestObject, languageSelected) {
    var result = ''
    var fieldsHeader = null
    if (this.definition) {
      fieldsHeader = this.definition.fieldsHeader
    }
    if (fieldsHeader) {
      for (var i = 0; i < fieldsHeader.length; i++) {
        var definition = transport.methods.getRequestDefinitionById(fieldsHeader[i], requestDefinition)
        var object = transport.methods.getRequestObjectById(fieldsHeader[i], requestObject)

        if (definition && object) {
          var textValue = transport.methods.getObjectTextValue(this.definition, definition, object, languageSelected)
          if (textValue === '') {
            textValue = ''
          } else {
            textValue += ' '
          }
          result += textValue
        }
      }
    }
    
    // append id value
    if (result !== '') {
      var idValue = transport.methods.getIdValue(requestDefinition, requestObject)
      if (idValue && idValue !== '') {
        result += '<span class="definition-title-id"> [' + idValue + ']</span>'
      }
    }

    return result.trim()
  }

  getJsonFieldsHeader (jsonObject, id) {
    var result = ''
    var fieldsHeader = null
    if (this.definition) {
      fieldsHeader = this.definition.fieldsHeader
    }
    if (fieldsHeader) {
      for (var i = 0; i < fieldsHeader.length; i++) {
        if (jsonObject) {
          var textValue = jsonObject[fieldsHeader[i]]
          if (textValue) {
            if (textValue === '') {
              textValue = ''
            } else if (textValue) {
              textValue += ' '
            }
          }
          result += textValue
        }
      }
    }
    
    // append id value
    if (result !== '' && id && id !== '') {
      result += '<span class="definition-title-id"> [' + id + ']</span>'      
    }

    return result.trim()
  }

  getDefinitionHeaderLang () {
    var result = ''

    if (this.definition && this.definition.headerLang) {
      result = this.definition.headerLang
    }

    return result
  }
}

export default Visual
